// Require the polyfill before requiring any other modules.
import Vue from 'vue'

import 'intersection-observer';
import 'default-passive-events';
import BootstrapVue from 'bootstrap-vue';
import Notifications from 'vue-notification'; //For SSR use import Notifications from 'vue-notification/dist/ssr.js'
import VeeValidate, {Validator} from 'vee-validate';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';
import * as VueLoaders from 'vue-loaders';

import App from './TheApp'
import router from './router'
import i18n from './i18n/index'
import store from './store'
import {actions} from './store/constants'
import apolloProvider from './graphql/apollo'
import * as filters from './filters' // global filters
import {auth} from './firebase'

/**
 * Import global components
 */
import ContactModal from '@/components/common/ContactModal'
import ContactPickerModal from '@/components/common/ContactPickerModal'
import SectionContentCard from '@/components/common/SectionContentCard'

import '@/components/_globals';

// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
});

/**
 * Install 3rd party modules globally
 */
Vue.use(BootstrapVue);
Vue.use(Notifications);
Vue.use(VeeValidate, {inject: false});
Vue.use(VueLoaders);

/**
 * Install app components globally
 */
Vue.component('contact-modal', ContactModal);
Vue.component('contact-picker-modal', ContactPickerModal);
Vue.component('SectionContentCard', SectionContentCard);



/**
 * Configure error tracking
 */
// Raven
//   .config('https://429caf47b9a44dbab62de08c72587867@sentry.io/1250673', {
//     release: '0e4fdef81448dcfa0e16ecc4433ff3997aa53572'
//   })
//   .addPlugin(RavenVue, Vue)
//   .install();


Vue.config.productionTip = false;
const env = process.env;

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  provide: apolloProvider.provide(),
  data() {
    return {
      loading: true
    }
  },
  render(h) {
    return h(App)
  },
});




// WEBPACK FOOTER //
// ./src/main.js